import type { ObituaryRequestBody } from '@/reports/searchReport';
import { searchReport } from '@/reports/searchReport';

export type ObituaryGenerateReportParams = {
  id?: string;
  'h-captcha-response'?: string;
};

export default function obituarySearch(params: ObituaryGenerateReportParams) {
  const body: ObituaryRequestBody = {
    report_type: 'obituary_report',
    meta: {
      obituary_id: params.id || '',
      report_flags: [],
    },
  };

  return searchReport(body);
}
